import { call, put, takeLatest } from "redux-saga/effects";
import axios, { AxiosResponse } from "axios";
import bffRequest from "@util/net/bff";
import { executeOnceAtATime } from "@util/net/index";
import {
  FavoritesItemActions,
  GET_FAVORITES_ITEM,
  POST_FAVORITES_ITEM,
  DELETE_FAVORITES_ITEM,
  ConfigActions
} from "@redux/reducer";
import {
  DelFavoritesItemPayload,
  FavoritesItemResponse,
  PostFavoritesItemPayload
} from "@type/index";
import store from "@redux/store";

// get favorites item list
export function* getFavoritesItemSaga() {
  try {
    yield put(FavoritesItemActions.getFavoritesItemLoading(true));
    const { region } = store.getState().config;
    const res: AxiosResponse<FavoritesItemResponse> = yield call(
      bffRequest.post,
      "/h/hmall-favorite-service/customer/favorite/list/zh_TW",
      {}
    );
    yield put(
      FavoritesItemActions.getFavoritesItemSuccess({
        data: res.data.resp,
        region
      })
    );
  } catch (error) {
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
  }
}

// add favorites item
export function* postFavoritesItemSaga(action: {
  payload: PostFavoritesItemPayload;
}) {
  try {
    const payload: PostFavoritesItemPayload = action.payload;
    yield put(FavoritesItemActions.getFavoritesItemLoading(true));
    const res: AxiosResponse<FavoritesItemResponse> = yield call(
      bffRequest.post,
      "/h/hmall-favorite-service/customer/favorite/insert/zh_TW",
      payload[0]
    );
    if (res.data.success) {
      yield put(FavoritesItemActions.postFavoritesItemSuccess(payload[0].l2Id));
    } else {
      store.dispatch(ConfigActions.setShowWishIconError(true));
      if (res.data.msgCode === "UR_FAVORITE_01") {
        store.dispatch(ConfigActions.setWishMaxError(true));
      }
    }
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
  } catch (error) {
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
    if (!axios.isCancel(error)) {
      const errorCode = JSON.parse(JSON.stringify(error)).status || null;
      if (errorCode && errorCode.toString() === "401") {
        yield put(ConfigActions.setShowLogin(true));
      } else {
        yield put(ConfigActions.setShowWishIconError(true));
      }
    }
  }
}

// del favorites item
export function* deleteFavoritesItemSaga(action: {
  payload: DelFavoritesItemPayload;
}) {
  try {
    const payload: DelFavoritesItemPayload = action.payload;
    yield put(FavoritesItemActions.getFavoritesItemLoading(true));
    const res: AxiosResponse<FavoritesItemResponse> = yield call(
      bffRequest.post,
      `/h/hmall-favorite-service/customer/favorite/delete/${payload[0]}/zh_TW`,
      {}
    );
    if (res.data.success) {
      yield put(FavoritesItemActions.delFavoritesItemSuccess(payload[0]));
    }
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
  } catch (error) {
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
    if (!axios.isCancel(error)) {
      const errorCode = JSON.parse(JSON.stringify(error)).status || null;
      if (errorCode && errorCode.toString() === "401") {
        yield put(ConfigActions.setShowLogin(true));
      } else {
        yield put(ConfigActions.setShowWishIconError(true));
      }
    }
  }
}

export const addWishlistStylingBookItem = executeOnceAtATime(
  postFavoritesItemSaga
);
export const delWishlistStylingBookItem = executeOnceAtATime(
  deleteFavoritesItemSaga
);

export function* watchLoadFavoritesItemSaga() {
  yield takeLatest<any>(GET_FAVORITES_ITEM, getFavoritesItemSaga);
  yield takeLatest<any>(POST_FAVORITES_ITEM, addWishlistStylingBookItem);
  yield takeLatest<any>(DELETE_FAVORITES_ITEM, delWishlistStylingBookItem);
}
